module.exports = ".div-space {\r\n  padding-top: 20px;\r\n}\r\n\r\n.push-0-t {\r\n  margin-top: 0px !important;\r\n}\r\n\r\n.required-star {\r\n  font-size: 18px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tryout-custom-questions/tryout-custom-questions.component.css
// module id = ./src/app/shared/components/tryout-custom-questions/tryout-custom-questions.component.css
// module chunks = main